import {useEffect} from "react";
import {useCookies} from "react-cookie";
import {datePlusDays} from "../components/utils/Utils";
import {useNavigate} from "react-router-dom";

const QrBusinessCardHome = () => {

    const [cookie, setCookie] = useCookies(['qrbc'])
    const navigate = useNavigate()

    useEffect(() => {
        setCookie('qrbc', 'true', {
            expires: datePlusDays(1)
        })
    }, []);

    useEffect(() => {
        navigate('/')
    }, [cookie]);

    return (
        <>
        </>
    )
}

export default QrBusinessCardHome;